import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';
import TextSectionSkeleton from '../../../../components/skeletons/TextSectionSkeleton';
import useMediaQuery from '../../../../utils/hooks/mediaQuery.hook';
import { HEADER_IMAGE_DIMENSIONS, HEADER_IMAGE_SM_DIMENSIONS } from '../../constants';

const CampaignHeaderSkeleton = () => {
  const { isMobile } = useMediaQuery();

  const style = isMobile
    ? { background: 'var(--bs-light)' }
    : { background: 'linear-gradient(to right, white 35%, var(--bs-light) 0%)' };

  const imageDimensions = isMobile ? HEADER_IMAGE_SM_DIMENSIONS : HEADER_IMAGE_DIMENSIONS;

  return (
    <div className="py-md-5" style={style}>
      <Container>
        <Row>
          <Col xs={12} md={6} className="p-0 p-sm-3 text-center">
            <SkeletonElement type="header-image" style={imageDimensions} />
          </Col>
          <Col xs={12} md={6} className="align-self-center">
            <div className="py-3 px-md-3">
              <TextSectionSkeleton />
              <br />
              <SkeletonElement type="label-short" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CampaignHeaderSkeleton;
